/*
 * Public API Surface of timer
 */

export * from './lib/timer.service';
export * from './lib/timer.component';
export * from './lib/timer.module';
